import { createSelector } from 'reselect';
import { getMetricsAlertHistory } from '../rootSelectors';

const getMetricsAlertHistoryData = createSelector([getMetricsAlertHistory], metricsAlertHistory => metricsAlertHistory);

export { getMetricsAlertHistoryData };
